import { createRouteLoader, WrapRouteComponent, RouteErrorComponent } from '@ice/runtime';
import type { CreateRoutes } from '@ice/runtime';
const createRoutes: CreateRoutes = ({
  requestContext,
  renderMode,
}) => ([
  {
    path: '',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_layout" */ '@/pages/layout');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'layout',
          isLayout: true,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'layout',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'layout',
    index: undefined,
    id: 'layout',
    exact: true,
    exports: ["default"],
    layout: true,
    children: [{
      path: 'coupon/details/component/SubPageWarrper',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-component-subpagewarrper-index" */ '@/pages/coupon/details/component/SubPageWarrper/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/component/SubPageWarrper',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/component/SubPageWarrper',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-component-subpagewarrper-index',
      index: true,
      id: 'coupon/details/component/SubPageWarrper',
      exact: true,
      exports: ["default"],
    },{
      path: 'activityAndVip/components/activityList',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_activityandvip-components-activitylist-index" */ '@/pages/activityAndVip/components/activityList/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'activityAndVip/components/activityList',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'activityAndVip/components/activityList',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'activityandvip-components-activitylist-index',
      index: true,
      id: 'activityAndVip/components/activityList',
      exact: true,
      exports: ["default"],
    },{
      path: 'coupon/details/component/CouponContent',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-component-couponcontent-index" */ '@/pages/coupon/details/component/CouponContent/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/component/CouponContent',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/component/CouponContent',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-component-couponcontent-index',
      index: true,
      id: 'coupon/details/component/CouponContent',
      exact: true,
      exports: ["default"],
    },{
      path: 'point/orderDetail/hooks/storeOrderDetailInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-orderdetail-hooks-storeorderdetailinit" */ '@/pages/point/orderDetail/hooks/storeOrderDetailInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/orderDetail/hooks/storeOrderDetailInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/orderDetail/hooks/storeOrderDetailInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-orderdetail-hooks-storeorderdetailinit',
      index: undefined,
      id: 'point/orderDetail/hooks/storeOrderDetailInit',
      exact: true,
      exports: ["storeOrderDetailInit"],
    },{
      path: 'coupon/details/component/OrderContent',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-component-ordercontent-index" */ '@/pages/coupon/details/component/OrderContent/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/component/OrderContent',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/component/OrderContent',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-component-ordercontent-index',
      index: true,
      id: 'coupon/details/component/OrderContent',
      exact: true,
      exports: ["default"],
    },{
      path: 'order/confirm/components/SelectCoupon',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-confirm-components-selectcoupon-index" */ '@/pages/order/confirm/components/SelectCoupon/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/confirm/components/SelectCoupon',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/confirm/components/SelectCoupon',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-confirm-components-selectcoupon-index',
      index: true,
      id: 'order/confirm/components/SelectCoupon',
      exact: true,
      exports: ["default"],
    },{
      path: 'coupon/details/component/SpecialRule',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-component-specialrule-index" */ '@/pages/coupon/details/component/SpecialRule/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/component/SpecialRule',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/component/SpecialRule',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-component-specialrule-index',
      index: true,
      id: 'coupon/details/component/SpecialRule',
      exact: true,
      exports: ["default"],
    },{
      path: 'coupon/details/component/CinemaList',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-component-cinemalist-index" */ '@/pages/coupon/details/component/CinemaList/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/component/CinemaList',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/component/CinemaList',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-component-cinemalist-index',
      index: true,
      id: 'coupon/details/component/CinemaList',
      exact: true,
      exports: ["default"],
    },{
      path: 'coupon/details/component/NormalList',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-component-normallist-index" */ '@/pages/coupon/details/component/NormalList/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/component/NormalList',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/component/NormalList',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-component-normallist-index',
      index: true,
      id: 'coupon/details/component/NormalList',
      exact: true,
      exports: ["default"],
    },{
      path: 'coupon/details/component/PriceRule',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-component-pricerule-index" */ '@/pages/coupon/details/component/PriceRule/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/component/PriceRule',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/component/PriceRule',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-component-pricerule-index',
      index: true,
      id: 'coupon/details/component/PriceRule',
      exact: true,
      exports: ["default"],
    },{
      path: 'order/confirm/components/InputAia',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-confirm-components-inputaia-index" */ '@/pages/order/confirm/components/InputAia/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/confirm/components/InputAia',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/confirm/components/InputAia',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-confirm-components-inputaia-index',
      index: true,
      id: 'order/confirm/components/InputAia',
      exact: true,
      exports: ["default"],
    },{
      path: 'agreement/list/hooks/agreementListInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_agreement-list-hooks-agreementlistinit" */ '@/pages/agreement/list/hooks/agreementListInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'agreement/list/hooks/agreementListInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'agreement/list/hooks/agreementListInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'agreement-list-hooks-agreementlistinit',
      index: undefined,
      id: 'agreement/list/hooks/agreementListInit',
      exact: true,
      exports: ["agreementListInit"],
    },{
      path: 'point/complete/hooks/storeCompleteInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-complete-hooks-storecompleteinit" */ '@/pages/point/complete/hooks/storeCompleteInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/complete/hooks/storeCompleteInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/complete/hooks/storeCompleteInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-complete-hooks-storecompleteinit',
      index: undefined,
      id: 'point/complete/hooks/storeCompleteInit',
      exact: true,
      exports: ["storeCompleteInit"],
    },{
      path: 'payment/result/hooks/usePayResultInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-hooks-usepayresultinit" */ '@/pages/payment/result/hooks/usePayResultInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result/hooks/usePayResultInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result/hooks/usePayResultInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-hooks-usepayresultinit',
      index: undefined,
      id: 'payment/result/hooks/usePayResultInit',
      exact: true,
      exports: ["usePayResultInit"],
    },{
      path: 'payment/result/hooks/usePayResultNext',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-hooks-usepayresultnext" */ '@/pages/payment/result/hooks/usePayResultNext');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result/hooks/usePayResultNext',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result/hooks/usePayResultNext',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-hooks-usepayresultnext',
      index: undefined,
      id: 'payment/result/hooks/usePayResultNext',
      exact: true,
      exports: ["usePayResultNext"],
    },{
      path: 'user/levelRules/component/Table',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-levelrules-component-table-index" */ '@/pages/user/levelRules/component/Table/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/levelRules/component/Table',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/levelRules/component/Table',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-levelrules-component-table-index',
      index: true,
      id: 'user/levelRules/component/Table',
      exact: true,
      exports: ["default"],
    },{
      path: 'seat/components/TicketTypeItem',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-components-tickettypeitem-index" */ '@/pages/seat/components/TicketTypeItem/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/components/TicketTypeItem',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/components/TicketTypeItem',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-components-tickettypeitem-index',
      index: true,
      id: 'seat/components/TicketTypeItem',
      exact: true,
      exports: ["default"],
    },{
      path: 'user/logoff/component/Protocol',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-logoff-component-protocol-index" */ '@/pages/user/logoff/component/Protocol/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/logoff/component/Protocol',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/logoff/component/Protocol',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-logoff-component-protocol-index',
      index: true,
      id: 'user/logoff/component/Protocol',
      exact: true,
      exports: ["default"],
    },{
      path: 'coupon/details/hooks/useRenderRules',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-hooks-userenderrules" */ '@/pages/coupon/details/hooks/useRenderRules');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/hooks/useRenderRules',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/hooks/useRenderRules',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-hooks-userenderrules',
      index: undefined,
      id: 'coupon/details/hooks/useRenderRules',
      exact: true,
      exports: ["renderRulesElement"],
    },{
      path: 'seat/components/SeatPlanModal',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-components-seatplanmodal-index" */ '@/pages/seat/components/SeatPlanModal/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/components/SeatPlanModal',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/components/SeatPlanModal',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-components-seatplanmodal-index',
      index: true,
      id: 'seat/components/SeatPlanModal',
      exact: true,
      exports: ["SeatPlanModal","default"],
    },{
      path: 'component/activityList',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index-component-activitylist-index" */ '@/pages/index/component/activityList/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'component/activityList',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'component/activityList',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index-component-activitylist-index',
      index: true,
      id: 'component/activityList',
      exact: true,
      exports: ["default"],
    },{
      path: 'paymenthooks/usePaymentInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-index-hooks-usepaymentinit" */ '@/pages/payment/index/hooks/usePaymentInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'paymenthooks/usePaymentInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'paymenthooks/usePaymentInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-index-hooks-usepaymentinit',
      index: undefined,
      id: 'paymenthooks/usePaymentInit',
      exact: true,
      exports: ["usePaymentInit"],
    },{
      path: 'paymenthooks/usePaymentNext',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-index-hooks-usepaymentnext" */ '@/pages/payment/index/hooks/usePaymentNext');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'paymenthooks/usePaymentNext',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'paymenthooks/usePaymentNext',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-index-hooks-usepaymentnext',
      index: undefined,
      id: 'paymenthooks/usePaymentNext',
      exact: true,
      exports: ["usePaymentNext"],
    },{
      path: 'point/detail/hooks/storeDetailInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-detail-hooks-storedetailinit" */ '@/pages/point/detail/hooks/storeDetailInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/detail/hooks/storeDetailInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/detail/hooks/storeDetailInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-detail-hooks-storedetailinit',
      index: undefined,
      id: 'point/detail/hooks/storeDetailInit',
      exact: true,
      exports: ["storeDetailInit"],
    },{
      path: 'seat/components/TicketSelect',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-components-ticketselect-index" */ '@/pages/seat/components/TicketSelect/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/components/TicketSelect',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/components/TicketSelect',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-components-ticketselect-index',
      index: true,
      id: 'seat/components/TicketSelect',
      exact: true,
      exports: ["default"],
    },{
      path: 'card/detail/hooks/useCardSellInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-detail-hooks-usecardsellinit" */ '@/pages/card/detail/hooks/useCardSellInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/detail/hooks/useCardSellInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/detail/hooks/useCardSellInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-detail-hooks-usecardsellinit',
      index: undefined,
      id: 'card/detail/hooks/useCardSellInit',
      exact: true,
      exports: ["useCardSellInit"],
    },{
      path: 'card/detail/hooks/useCardSellNext',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-detail-hooks-usecardsellnext" */ '@/pages/card/detail/hooks/useCardSellNext');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/detail/hooks/useCardSellNext',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/detail/hooks/useCardSellNext',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-detail-hooks-usecardsellnext',
      index: undefined,
      id: 'card/detail/hooks/useCardSellNext',
      exact: true,
      exports: ["useCardSellNext"],
    },{
      path: 'payment/result/page/default',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-page-default-index" */ '@/pages/payment/result/page/default/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result/page/default',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result/page/default',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-page-default-index',
      index: true,
      id: 'payment/result/page/default',
      exact: true,
      exports: ["default"],
    },{
      path: 'order/confirm/page/default',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-confirm-page-default-index" */ '@/pages/order/confirm/page/default/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/confirm/page/default',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/confirm/page/default',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-confirm-page-default-index',
      index: true,
      id: 'order/confirm/page/default',
      exact: true,
      exports: ["default"],
    },{
      path: 'paymentpage/default',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-index-page-default-index" */ '@/pages/payment/index/page/default/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'paymentpage/default',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'paymentpage/default',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-index-page-default-index',
      index: true,
      id: 'paymentpage/default',
      exact: true,
      exports: ["default"],
    },{
      path: 'payment/result/page/galaxy',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-page-galaxy-index" */ '@/pages/payment/result/page/galaxy/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result/page/galaxy',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result/page/galaxy',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-page-galaxy-index',
      index: true,
      id: 'payment/result/page/galaxy',
      exact: true,
      exports: ["default"],
    },{
      path: 'point/order/hooks/storeOrderInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-order-hooks-storeorderinit" */ '@/pages/point/order/hooks/storeOrderInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/order/hooks/storeOrderInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/order/hooks/storeOrderInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-order-hooks-storeorderinit',
      index: undefined,
      id: 'point/order/hooks/storeOrderInit',
      exact: true,
      exports: ["storeOrderInit"],
    },{
      path: 'seat/components/TicketType',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-components-tickettype-index" */ '@/pages/seat/components/TicketType/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/components/TicketType',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/components/TicketType',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-components-tickettype-index',
      index: true,
      id: 'seat/components/TicketType',
      exact: true,
      exports: ["TicketType"],
    },{
      path: 'card/list/hooks/useCardListInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-list-hooks-usecardlistinit" */ '@/pages/card/list/hooks/useCardListInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/list/hooks/useCardListInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/list/hooks/useCardListInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-list-hooks-usecardlistinit',
      index: undefined,
      id: 'card/list/hooks/useCardListInit',
      exact: true,
      exports: ["useCardSellInit"],
    },{
      path: 'card/list/hooks/useCardListNext',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-list-hooks-usecardlistnext" */ '@/pages/card/list/hooks/useCardListNext');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/list/hooks/useCardListNext',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/list/hooks/useCardListNext',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-list-hooks-usecardlistnext',
      index: undefined,
      id: 'card/list/hooks/useCardListNext',
      exact: true,
      exports: ["useCardListNext"],
    },{
      path: 'card/sell/hooks/useCardSellInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-sell-hooks-usecardsellinit" */ '@/pages/card/sell/hooks/useCardSellInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/sell/hooks/useCardSellInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/sell/hooks/useCardSellInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-sell-hooks-usecardsellinit',
      index: undefined,
      id: 'card/sell/hooks/useCardSellInit',
      exact: true,
      exports: ["useCardSellInit"],
    },{
      path: 'card/sell/hooks/useCardSellNext',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-sell-hooks-usecardsellnext" */ '@/pages/card/sell/hooks/useCardSellNext');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/sell/hooks/useCardSellNext',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/sell/hooks/useCardSellNext',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-sell-hooks-usecardsellnext',
      index: undefined,
      id: 'card/sell/hooks/useCardSellNext',
      exact: true,
      exports: ["useCardSellNext"],
    },{
      path: 'coupon/details/hooks/useDetails',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-hooks-usedetails" */ '@/pages/coupon/details/hooks/useDetails');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/hooks/useDetails',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/hooks/useDetails',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-hooks-usedetails',
      index: undefined,
      id: 'coupon/details/hooks/useDetails',
      exact: true,
      exports: ["getFilmNames","judgeIsEllipsis","useInit","useSetTitle","useTabPanle","useToBack"],
    },{
      path: 'component/movieList',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index-component-movielist-index" */ '@/pages/index/component/movieList/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'component/movieList',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'component/movieList',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index-component-movielist-index',
      index: true,
      id: 'component/movieList',
      exact: true,
      exports: ["default","filmLevel"],
    },{
      path: 'order/confirm/page/galaxy',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-confirm-page-galaxy-index" */ '@/pages/order/confirm/page/galaxy/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/confirm/page/galaxy',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/confirm/page/galaxy',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-confirm-page-galaxy-index',
      index: true,
      id: 'order/confirm/page/galaxy',
      exact: true,
      exports: ["default"],
    },{
      path: 'paymentpage/galaxy',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-index-page-galaxy-index" */ '@/pages/payment/index/page/galaxy/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'paymentpage/galaxy',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'paymentpage/galaxy',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-index-page-galaxy-index',
      index: true,
      id: 'paymentpage/galaxy',
      exact: true,
      exports: ["default"],
    },{
      path: 'point/myPoint/hooks/myPointInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-mypoint-hooks-mypointinit" */ '@/pages/point/myPoint/hooks/myPointInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/myPoint/hooks/myPointInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/myPoint/hooks/myPointInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-mypoint-hooks-mypointinit',
      index: undefined,
      id: 'point/myPoint/hooks/myPointInit',
      exact: true,
      exports: ["myPointInit"],
    },{
      path: 'showtimes/page/defalut/skeleton',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_showtimes-page-defalut-skeleton" */ '@/pages/showtimes/page/defalut/skeleton');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'showtimes/page/defalut/skeleton',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'showtimes/page/defalut/skeleton',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'showtimes-page-defalut-skeleton',
      index: undefined,
      id: 'showtimes/page/defalut/skeleton',
      exact: true,
      exports: ["default"],
    },{
      path: 'order/list/component/OrderItem',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-list-component-orderitem" */ '@/pages/order/list/component/OrderItem');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/list/component/OrderItem',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/list/component/OrderItem',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-list-component-orderitem',
      index: undefined,
      id: 'order/list/component/OrderItem',
      exact: true,
      exports: ["default"],
    },{
      path: 'payment/result/hooks/useHelper',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-hooks-usehelper" */ '@/pages/payment/result/hooks/useHelper');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result/hooks/useHelper',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result/hooks/useHelper',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-hooks-usehelper',
      index: undefined,
      id: 'payment/result/hooks/useHelper',
      exact: true,
      exports: ["getPaymentName"],
    },{
      path: 'seat/components/SeatDesk',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-components-seatdesk-index" */ '@/pages/seat/components/SeatDesk/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/components/SeatDesk',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/components/SeatDesk',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-components-seatdesk-index',
      index: true,
      id: 'seat/components/SeatDesk',
      exact: true,
      exports: ["SeatDesk"],
    },{
      path: 'showtimes/page/galaxy/skeleton',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_showtimes-page-galaxy-skeleton" */ '@/pages/showtimes/page/galaxy/skeleton');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'showtimes/page/galaxy/skeleton',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'showtimes/page/galaxy/skeleton',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'showtimes-page-galaxy-skeleton',
      index: undefined,
      id: 'showtimes/page/galaxy/skeleton',
      exact: true,
      exports: ["default"],
    },{
      path: 'film/component/filmList',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_film-component-filmlist-index" */ '@/pages/film/component/filmList/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'film/component/filmList',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'film/component/filmList',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'film-component-filmlist-index',
      index: true,
      id: 'film/component/filmList',
      exact: true,
      exports: ["default"],
    },{
      path: 'component/vipList',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index-component-viplist-index" */ '@/pages/index/component/vipList/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'component/vipList',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'component/vipList',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index-component-viplist-index',
      index: true,
      id: 'component/vipList',
      exact: true,
      exports: ["default"],
    },{
      path: 'pos/list/hooks/usePosListInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_pos-list-hooks-useposlistinit" */ '@/pages/pos/list/hooks/usePosListInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'pos/list/hooks/usePosListInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'pos/list/hooks/usePosListInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'pos-list-hooks-useposlistinit',
      index: undefined,
      id: 'pos/list/hooks/usePosListInit',
      exact: true,
      exports: ["usePosListInit"],
    },{
      path: 'showtimes/hooks/useScreenInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_showtimes-hooks-usescreeninit" */ '@/pages/showtimes/hooks/useScreenInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'showtimes/hooks/useScreenInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'showtimes/hooks/useScreenInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'showtimes-hooks-usescreeninit',
      index: undefined,
      id: 'showtimes/hooks/useScreenInit',
      exact: true,
      exports: ["useScreenInit"],
    },{
      path: 'showtimes/hooks/useTabConfig',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_showtimes-hooks-usetabconfig" */ '@/pages/showtimes/hooks/useTabConfig');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'showtimes/hooks/useTabConfig',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'showtimes/hooks/useTabConfig',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'showtimes-hooks-usetabconfig',
      index: undefined,
      id: 'showtimes/hooks/useTabConfig',
      exact: true,
      exports: ["useTabConfig"],
    },{
      path: 'showtimes/page/defalut',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_showtimes-page-defalut-index" */ '@/pages/showtimes/page/defalut/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'showtimes/page/defalut',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'showtimes/page/defalut',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'showtimes-page-defalut-index',
      index: true,
      id: 'showtimes/page/defalut',
      exact: true,
      exports: ["default"],
    },{
      path: 'order/hooks/useOrderConfirm',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-hooks-useorderconfirm" */ '@/pages/order/hooks/useOrderConfirm');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/hooks/useOrderConfirm',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/hooks/useOrderConfirm',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-hooks-useorderconfirm',
      index: undefined,
      id: 'order/hooks/useOrderConfirm',
      exact: true,
      exports: ["useOrderConfirm"],
    },{
      path: 'point/store/hooks/storeInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-store-hooks-storeinit" */ '@/pages/point/store/hooks/storeInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/store/hooks/storeInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/store/hooks/storeInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-store-hooks-storeinit',
      index: undefined,
      id: 'point/store/hooks/storeInit',
      exact: true,
      exports: ["storeInit"],
    },{
      path: 'showtimes/page/galaxy',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_showtimes-page-galaxy-index" */ '@/pages/showtimes/page/galaxy/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'showtimes/page/galaxy',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'showtimes/page/galaxy',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'showtimes-page-galaxy-index',
      index: true,
      id: 'showtimes/page/galaxy',
      exact: true,
      exports: ["WEEKDAY","default"],
    },{
      path: 'user/levelRules/const',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-levelrules-const-index" */ '@/pages/user/levelRules/const/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/levelRules/const',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/levelRules/const',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-levelrules-const-index',
      index: true,
      id: 'user/levelRules/const',
      exact: true,
      exports: ["growthHeadList","rightsHeaderList"],
    },{
      path: 'coupon/details/const',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-const-index" */ '@/pages/coupon/details/const/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details/const',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details/const',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-const-index',
      index: true,
      id: 'coupon/details/const',
      exact: true,
      exports: ["FLIM_CASH_COUPON_RULES","FLIM_DISCOUNT_COUPON_RULES","FLIM_EXCHANGE_VOUCHER_RULES","FLIM_REPRICE_COUPON_RULES","ORDER_CASH_COUPON_RULES","ORDER_DISCOUNT_COUPON_RULES","ORDER_EXCHANGE_VOUCHER_RULES","ORDER_REPRICE_COUPON_RULES","pageTypeObj"],
    },{
      path: 'order/hooks/useConfirmInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-hooks-useconfirminit" */ '@/pages/order/hooks/useConfirmInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/hooks/useConfirmInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/hooks/useConfirmInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-hooks-useconfirminit',
      index: undefined,
      id: 'order/hooks/useConfirmInit',
      exact: true,
      exports: ["useConfirmInit"],
    },{
      path: 'payment/result/hooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-hooks-index" */ '@/pages/payment/result/hooks/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result/hooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result/hooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-hooks-index',
      index: true,
      id: 'payment/result/hooks',
      exact: true,
      exports: [],
    },{
      path: 'user/detail/component/Form',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-detail-component-form" */ '@/pages/user/detail/component/Form');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/detail/component/Form',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/detail/component/Form',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-detail-component-form',
      index: undefined,
      id: 'user/detail/component/Form',
      exact: true,
      exports: ["default"],
    },{
      path: 'user/levelRules/hooks/init',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-levelrules-hooks-init" */ '@/pages/user/levelRules/hooks/init');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/levelRules/hooks/init',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/levelRules/hooks/init',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-levelrules-hooks-init',
      index: undefined,
      id: 'user/levelRules/hooks/init',
      exact: true,
      exports: ["useInit"],
    },{
      path: 'membership/benefits',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_membership-benefits-index" */ '@/pages/membership/benefits/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'membership/benefits',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'membership/benefits',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'membership-benefits-index',
      index: true,
      id: 'membership/benefits',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'paymenthooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-index-hooks-index" */ '@/pages/payment/index/hooks/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'paymenthooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'paymenthooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-index-hooks-index',
      index: true,
      id: 'paymenthooks',
      exact: true,
      exports: [],
    },{
      path: 'payment/result/mail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-mail-index" */ '@/pages/payment/result/mail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result/mail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result/mail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-mail-index',
      index: true,
      id: 'payment/result/mail',
      exact: true,
      exports: ["default"],
    },{
      path: 'film/component/nav',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_film-component-nav-index" */ '@/pages/film/component/nav/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'film/component/nav',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'film/component/nav',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'film-component-nav-index',
      index: true,
      id: 'film/component/nav',
      exact: true,
      exports: ["default"],
    },{
      path: 'membership/benefits/mock',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_membership-benefits-mock" */ '@/pages/membership/benefits/mock');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'membership/benefits/mock',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'membership/benefits/mock',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'membership-benefits-mock',
      index: undefined,
      id: 'membership/benefits/mock',
      exact: true,
      exports: ["accountLevelData","allLevelData"],
    },{
      path: 'order/hooks/useCountdown',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-hooks-usecountdown" */ '@/pages/order/hooks/useCountdown');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/hooks/useCountdown',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/hooks/useCountdown',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-hooks-usecountdown',
      index: undefined,
      id: 'order/hooks/useCountdown',
      exact: true,
      exports: ["useCountdownFn"],
    },{
      path: 'seat/hooks/useCinemaArea',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-hooks-usecinemaarea" */ '@/pages/seat/hooks/useCinemaArea');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/hooks/useCinemaArea',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/hooks/useCinemaArea',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-hooks-usecinemaarea',
      index: undefined,
      id: 'seat/hooks/useCinemaArea',
      exact: true,
      exports: ["useCinemaArea"],
    },{
      path: 'seat/hooks/useSeatToasts',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-hooks-useseattoasts" */ '@/pages/seat/hooks/useSeatToasts');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/hooks/useSeatToasts',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/hooks/useSeatToasts',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-hooks-useseattoasts',
      index: undefined,
      id: 'seat/hooks/useSeatToasts',
      exact: true,
      exports: ["seatPrompt","usePoup"],
    },{
      path: 'agreement/privacy',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_agreement-privacy-index" */ '@/pages/agreement/privacy/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'agreement/privacy',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'agreement/privacy',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'agreement-privacy-index',
      index: true,
      id: 'agreement/privacy',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'coupon/list/const',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-list-const-index" */ '@/pages/coupon/list/const/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/list/const',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/list/const',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-list-const-index',
      index: true,
      id: 'coupon/list/const',
      exact: true,
      exports: ["tabItem"],
    },{
      path: 'payment/cardApply',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-cardapply-index" */ '@/pages/payment/cardApply/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/cardApply',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/cardApply',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-cardapply-index',
      index: true,
      id: 'payment/cardApply',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'point/orderDetail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-orderdetail-index" */ '@/pages/point/orderDetail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/orderDetail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/orderDetail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-orderdetail-index',
      index: true,
      id: 'point/orderDetail',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'seat/hooks/useSeatToast',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-hooks-useseattoast" */ '@/pages/seat/hooks/useSeatToast');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/hooks/useSeatToast',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/hooks/useSeatToast',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-hooks-useseattoast',
      index: undefined,
      id: 'seat/hooks/useSeatToast',
      exact: true,
      exports: ["useSeatToast"],
    },{
      path: 'seat/page/default',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-page-default-index" */ '@/pages/seat/page/default/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/page/default',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/page/default',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-page-default-index',
      index: true,
      id: 'seat/page/default',
      exact: true,
      exports: ["default"],
    },{
      path: 'user/detail/hooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-detail-hooks-index" */ '@/pages/user/detail/hooks/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/detail/hooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/detail/hooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-detail-hooks-index',
      index: true,
      id: 'user/detail/hooks',
      exact: true,
      exports: ["useInit","useToastForm"],
    },{
      path: 'user/logoff/const',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-logoff-const-index" */ '@/pages/user/logoff/const/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/logoff/const',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/logoff/const',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-logoff-const-index',
      index: true,
      id: 'user/logoff/const',
      exact: true,
      exports: ["reasonsList"],
    },{
      path: 'coupon/list/hooks/init',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-list-hooks-init" */ '@/pages/coupon/list/hooks/init');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/list/hooks/init',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/list/hooks/init',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-list-hooks-init',
      index: undefined,
      id: 'coupon/list/hooks/init',
      exact: true,
      exports: ["useInit"],
    },{
      path: 'payment/recharge',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-recharge-index" */ '@/pages/payment/recharge/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/recharge',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/recharge',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-recharge-index',
      index: true,
      id: 'payment/recharge',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'seat/hooks/useSeatInit',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-hooks-useseatinit" */ '@/pages/seat/hooks/useSeatInit');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/hooks/useSeatInit',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/hooks/useSeatInit',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-hooks-useseatinit',
      index: undefined,
      id: 'seat/hooks/useSeatInit',
      exact: true,
      exports: ["useSeatInit"],
    },{
      path: 'seat/hooks/useSeatNext',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-hooks-useseatnext" */ '@/pages/seat/hooks/useSeatNext');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/hooks/useSeatNext',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/hooks/useSeatNext',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-hooks-useseatnext',
      index: undefined,
      id: 'seat/hooks/useSeatNext',
      exact: true,
      exports: ["useSeatNext"],
    },{
      path: 'seat/page/galaxy',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-page-galaxy-index" */ '@/pages/seat/page/galaxy/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/page/galaxy',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/page/galaxy',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-page-galaxy-index',
      index: true,
      id: 'seat/page/galaxy',
      exact: true,
      exports: ["default"],
    },{
      path: 'user/logoff/hooks/step',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-logoff-hooks-step" */ '@/pages/user/logoff/hooks/step');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/logoff/hooks/step',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/logoff/hooks/step',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-logoff-hooks-step',
      index: undefined,
      id: 'user/logoff/hooks/step',
      exact: true,
      exports: ["useStepNext"],
    },{
      path: 'activity/detail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_activity-detail-index" */ '@/pages/activity/detail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'activity/detail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'activity/detail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'activity-detail-index',
      index: true,
      id: 'activity/detail',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'user/levelRules',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-levelrules-index" */ '@/pages/user/levelRules/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/levelRules',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/levelRules',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-levelrules-index',
      index: true,
      id: 'user/levelRules',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'activityAndVip/hooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_activityandvip-hooks" */ '@/pages/activityAndVip/hooks');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'activityAndVip/hooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'activityAndVip/hooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'activityandvip-hooks',
      index: undefined,
      id: 'activityAndVip/hooks',
      exact: true,
      exports: ["default"],
    },{
      path: 'activityAndVip',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_activityandvip-index" */ '@/pages/activityAndVip/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'activityAndVip',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'activityAndVip',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'activityandvip-index',
      index: true,
      id: 'activityAndVip',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'agreement/list',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_agreement-list-index" */ '@/pages/agreement/list/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'agreement/list',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'agreement/list',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'agreement-list-index',
      index: true,
      id: 'agreement/list',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'card/agreement',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-agreement-index" */ '@/pages/card/agreement/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/agreement',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/agreement',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-agreement-index',
      index: true,
      id: 'card/agreement',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'coupon/details',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-details-index" */ '@/pages/coupon/details/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/details',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/details',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-details-index',
      index: true,
      id: 'coupon/details',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'payment/result',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-index" */ '@/pages/payment/result/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/result',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/result',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-result-index',
      index: true,
      id: 'payment/result',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'point/complete',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-complete-index" */ '@/pages/point/complete/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/complete',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/complete',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-complete-index',
      index: true,
      id: 'point/complete',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'card/complete',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-complete-index" */ '@/pages/card/complete/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/complete',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/complete',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-complete-index',
      index: true,
      id: 'card/complete',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'card/recharge',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-recharge-index" */ '@/pages/card/recharge/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/recharge',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/recharge',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-recharge-index',
      index: true,
      id: 'card/recharge',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'cinema/detail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_cinema-detail-index" */ '@/pages/cinema/detail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'cinema/detail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'cinema/detail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'cinema-detail-index',
      index: true,
      id: 'cinema/detail',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'order/confirm',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-confirm-index" */ '@/pages/order/confirm/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/confirm',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/confirm',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-confirm-index',
      index: true,
      id: 'order/confirm',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'payment',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-index-index" */ '@/pages/payment/index/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-index-index',
      index: true,
      id: 'payment',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'payment/renew',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-renew-index" */ '@/pages/payment/renew/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'payment/renew',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'payment/renew',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'payment-renew-index',
      index: true,
      id: 'payment/renew',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'point/myPoint',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-mypoint-index" */ '@/pages/point/myPoint/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/myPoint',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/myPoint',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-mypoint-index',
      index: true,
      id: 'point/myPoint',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'user/feedback',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-feedback-index" */ '@/pages/user/feedback/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/feedback',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/feedback',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-feedback-index',
      index: true,
      id: 'user/feedback',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'coupon/const',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-const-index" */ '@/pages/coupon/const/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/const',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/const',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-const-index',
      index: true,
      id: 'coupon/const',
      exact: true,
      exports: ["couponTypeObj","useTypeObj"],
    },{
      path: 'point/detail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-detail-index" */ '@/pages/point/detail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/detail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/detail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-detail-index',
      index: true,
      id: 'point/detail',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'card/detail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-detail-index" */ '@/pages/card/detail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/detail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/detail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-detail-index',
      index: true,
      id: 'card/detail',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'coupon/list',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_coupon-list-index" */ '@/pages/coupon/list/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'coupon/list',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'coupon/list',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'coupon-list-index',
      index: true,
      id: 'coupon/list',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'hooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index-hooks" */ '@/pages/index/hooks');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'hooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'hooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index-hooks',
      index: undefined,
      id: 'hooks',
      exact: true,
      exports: ["default","useGetHotFilmListData","useGetSoonFilmData","useInitData","usePagesBannerLink"],
    },{
      path: 'order/const/order',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-const-order" */ '@/pages/order/const/order');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/const/order',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/const/order',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-const-order',
      index: undefined,
      id: 'order/const/order',
      exact: true,
      exports: ["orderStatusText"],
    },{
      path: 'order/hooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-hooks-index" */ '@/pages/order/hooks/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/hooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/hooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-hooks-index',
      index: true,
      id: 'order/hooks',
      exact: true,
      exports: [],
    },{
      path: 'order/hooks/useFn',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-hooks-usefn" */ '@/pages/order/hooks/useFn');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/hooks/useFn',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/hooks/useFn',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-hooks-usefn',
      index: undefined,
      id: 'order/hooks/useFn',
      exact: true,
      exports: ["useGetOrderList","useSeatText"],
    },{
      path: 'point/const',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-const-index" */ '@/pages/point/const/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/const',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/const',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-const-index',
      index: true,
      id: 'point/const',
      exact: true,
      exports: ["orderStatusEnum"],
    },{
      path: 'point/order',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-order-index" */ '@/pages/point/order/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/order',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/order',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-order-index',
      index: true,
      id: 'point/order',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'point/store',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_point-store-index" */ '@/pages/point/store/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'point/store',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'point/store',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'point-store-index',
      index: true,
      id: 'point/store',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'user/detail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-detail-index" */ '@/pages/user/detail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/detail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/detail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-detail-index',
      index: true,
      id: 'user/detail',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'user/logoff',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-logoff-index" */ '@/pages/user/logoff/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/logoff',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/logoff',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-logoff-index',
      index: true,
      id: 'user/logoff',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'order/list',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_order-list-index" */ '@/pages/order/list/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'order/list',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'order/list',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'order-list-index',
      index: true,
      id: 'order/list',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'pos/detail',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_pos-detail-index" */ '@/pages/pos/detail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'pos/detail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'pos/detail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'pos-detail-index',
      index: true,
      id: 'pos/detail',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'seat/hooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-hooks-index" */ '@/pages/seat/hooks/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat/hooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat/hooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-hooks-index',
      index: true,
      id: 'seat/hooks',
      exact: true,
      exports: ["useSeatInit","useSeatNext"],
    },{
      path: 'user',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-index-index" */ '@/pages/user/index/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-index-index',
      index: true,
      id: 'user',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'user/login',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_user-login-index" */ '@/pages/user/login/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'user/login',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'user/login',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'user-login-index',
      index: true,
      id: 'user/login',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'card/desc',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-desc-index" */ '@/pages/card/desc/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/desc',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/desc',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-desc-index',
      index: true,
      id: 'card/desc',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'card/list',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-list-index" */ '@/pages/card/list/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/list',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/list',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-list-index',
      index: true,
      id: 'card/list',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'card/sell',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-sell-index" */ '@/pages/card/sell/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/sell',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/sell',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-sell-index',
      index: true,
      id: 'card/sell',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'pos/detail/mock',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_pos-detail-mock" */ '@/pages/pos/detail/mock');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'pos/detail/mock',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'pos/detail/mock',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'pos-detail-mock',
      index: undefined,
      id: 'pos/detail/mock',
      exact: true,
      exports: ["mockData"],
    },{
      path: 'showtimes',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_showtimes-index" */ '@/pages/showtimes/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'showtimes',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'showtimes',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'showtimes-index',
      index: true,
      id: 'showtimes',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'activity/hooks',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_activity-hooks" */ '@/pages/activity/hooks');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'activity/hooks',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'activity/hooks',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'activity-hooks',
      index: undefined,
      id: 'activity/hooks',
      exact: true,
      exports: ["default"],
    },{
      path: 'card/add',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_card-add-index" */ '@/pages/card/add/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'card/add',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'card/add',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'card-add-index',
      index: true,
      id: 'card/add',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: '',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index-index" */ '@/pages/index/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index-index',
      index: true,
      id: '/',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'film',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_film-index" */ '@/pages/film/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'film',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'film',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'film-index',
      index: true,
      id: 'film',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'mall',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_mall-index" */ '@/pages/mall/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'mall',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'mall',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'mall-index',
      index: true,
      id: 'mall',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'seat',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_seat-index" */ '@/pages/seat/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'seat',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'seat',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'seat-index',
      index: true,
      id: 'seat',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 'err',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_err-index" */ '@/pages/err/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'err',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'err',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'err-index',
      index: true,
      id: 'err',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: 's',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_s-index" */ '@/pages/s/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 's',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 's',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 's-index',
      index: true,
      id: 's',
      exact: true,
      exports: ["dataLoader","default","pageConfig"],
    },{
      path: '*',
      async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_$" */ '@/pages/$');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: '$',
      index: undefined,
      id: '*',
      exact: true,
      exports: ["default"],
    },]
  },{
    path: '/index',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_layout" */ '@/pages/layout');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/index/layout',
          isLayout: true,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/index/layout',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'layout',
    index: undefined,
    id: '/index/layout',
    exact: true,
    exports: ["default"],
    layout: true,
  },{
    path: '/payment/result/mail',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_payment-result-mail-index" */ '@/pages/payment/result/mail/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/payment/result/mail',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/payment/result/mail',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'payment-result-mail-index',
    index: undefined,
    id: '/payment/result/mail',
    exact: true,
    exports: ["default"],
  },
]);
export default createRoutes;
